import {
    Modal,
    message
} from 'ant-design-vue'
import {
    createVNode
} from 'vue'
import {
    ExclamationCircleOutlined
} from '@ant-design/icons-vue'

import {
    Base64
} from 'js-base64'
import md5 from 'js-md5';

import store from '../store/index'

export default {
    setStorage(name, value) {
        return localStorage.setItem(name, value)
    },
    getStorage(name) {
        return localStorage.getItem(name)
    },
    removeStorage(name) {
        localStorage.removeItem(name)
    },
    setSessionStorage(name, value) {
        let operation = sessionStorage.setItem(name, value)
        return operation
    },
    getSessionStorage(name) {
        let operation = sessionStorage.getItem(name)
        return operation
    },
    /***
     * 手机号校验
     */
    checkTelephone(mobile) {
        if (!mobile && mobile != 0) {
            return false
        }
        if (typeof mobile == 'number') {
            mobile = mobile.toString()
        }
        var tel = /^0\d{2,3}-?\d{7,8}$/;
        var phone = /^1[3-9]\d{9}$/;
        if (mobile.length == 11) { //手机号码
            if (phone.test(mobile)) {
                return true;
            }
        } else if (mobile.length == 13 && mobile.indexOf("-") != -1) { //电话号码
            if (tel.test(mobile)) {
                return true;
            }
        } else {
            return false;
        }
    },
    message(type, str) {
        return message[type](str)
    },
    /**
     * 判断是否为空对象
     * @param {*} object 源对象
     */
    isEmptyObject(object) {
        return Object.keys(object).length === 0
    },
    /**
     * 判断是否为空
     * @param {*} object 源对象
     */
    isEmpty(value) {
        if (this.isArray(value)) {
            return value.length === 0
        }
        if (this.isObject(value)) {
            return this.isEmptyObject(value)
        }
        return !value
    },
    /**
     * 判断是否为对象
     * @param {*} array
     */
    isArray(array) {
        return Object.prototype.toString.call(array) === '[object Array]'
    },
    /**
     * 判断是否为对象
     * @param {*} object
     */
    isObject(object) {
        return Object.prototype.toString.call(object) === '[object Object]'
    },
    //正则校验替换保留n位小数,
    parseNumber(value, precision) {
        if (!precision) {
            precision = 2
        }
        if (value === undefined || value === null) return '';
        const regex = new RegExp(`^\\D*(\\d*(?:\\.\\d{0,${precision}})?)?.*$`, 'g');
        return value.replace(regex, '$1');
    },
    //特殊Base64加密
    setBase64(value) {
        if (value) {
            let text = this.generateRandomString()
            return text + Base64.encode(value);
        }
    },
    //解析特殊Base64加密
    getBase64(value) {
        if (value) {
            let newValue = value.slice(10)
            return Base64.decode(newValue);
        }
    },
    //生成随机字符串
    generateRandomString(digit = 10) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < digit; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },
    //进行md5加密
    setMd5Data(value) {
        return md5(value)
    },
    //判断密码规则
    getPaddwordRules(value) {
        // const Pattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,32}$/;
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,}$/;
        const continuous = /(.)\1{3,}/;
        if (passwordPattern.test(value) && !continuous.test(value)) {
            return true;
        }
        return false;
    },
    /**
     * 获取url 参数
     */
    get_query() {
        let query = {};
        let search = location.search
        if (search.length > 2) {
            search = search.split('?')[1].split('&')
            for (let i = 0; i < search.length; i++) {
                let arr = search[i].split('=');
                if (arr.length == 2) {
                    query[arr[0]] = arr[1]
                }
            }
        }
        return query
    },

    /**
     * 导出文件
     */
    exportFile(urls, name) {
        return new Promise((resolve, reject) => {
            const x = new window.XMLHttpRequest();
            x.open("GET", urls, true);
            x.responseType = "blob";
            x.onload = () => {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement("a");
                a.href = url;
                a.target = "_blank";
                a.download = name;
                a.click();
                resolve();
            };
            x.onerror = () => {
                reject();
            };
            x.send();
        });
    },
    // 删除及修改状态的方法-封装
    operationFun(data = {
        toast: true,
        cancelText: '取消',
        okText: '确定',
        type: 'confirm'
    }, apiName = null, where = {}) {
        let modalType = ['confirm', 'info', 'success', 'warning', 'error']
        data.toast = data.hasOwnProperty('toast') ? data.toast : true
        data.cancelText = data.hasOwnProperty('cancelText') ? data.cancelText : '取消'
        data.okText = data.hasOwnProperty('okText') ? data.okText : '确定'
        data.type = data.hasOwnProperty('type') && modalType.indexOf(data.type) != -1 ? data.type : 'confirm'
        return new Promise((resolve, reject) => {
            Modal[data.type]({
                content: data.content,
                title: data.title,
                icon: createVNode(ExclamationCircleOutlined),
                okText: data.okText,
                cancelText: data.cancelText,
                onOk() {
                    if (apiName) {
                        apiName({
                            data: {
                                ...where
                            },
                            toast: data.toast
                        }).then((res) => {
                            resolve(res)
                        })
                    } else {
                        resolve()
                    }
                },
                onCancel() {
                    reject()
                },
            });
        })
    },
}